import { render } from "./AddDiscussionProfile.vue?vue&type=template&id=3cbf5695"
import script from "./AddDiscussionProfile.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddDiscussionProfile.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddDiscussionProfile.vue?vue&type=style&index=0&id=3cbf5695&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__